import http from '../common/compornents/httpcommon';

class JuchuShokaiServ {
  // 生産拠点コンボボックスデータ取得
  getProdctHubList = () => {

    return http.get('JuchuShokai/getKsKyotenData')
  }

  // 納入先データ取得
  getNonyusakiList = (tokCd: String, tokCd2: String) => {
    var params = { tokCd: tokCd, tokCd2: tokCd2 };
    return http.get('JuchuShokai/getNonyusakiData/', { params });
  };

  // 共通コードマスタ（コンボボックス）データ取得
  getMCodeList = (code: String) => {
    var params = {
      code: code
    }
    return http.get('JuchuShokai/getMCode', { params })
  }

  //得意先名取得
  getTokName = (tokCd: String, tokCd2: String) => {
    var params = {
      tokCd: tokCd,
      tokCd2: tokCd2
    }
    return http.get('JuchuShokai/getTokuisakiName', { params })
  }

  //製品名先名取得
  getProductName = (tokCd: String, tokCd2: String, himmokuCd: String) => {
    var params = {
      tokCd: tokCd,
      tokCd2: tokCd2,
      himmokuCd: himmokuCd,
    }
    return http.get('JuchuShokai/getHimmokuName', { params })
  }

  // 検索結果取得
  getSearchList = (tokCd: String, tokCd2: String, nokiAns: String, orderDateS: String, orderDateE: String,
    orderNo: String, shipStatus: String, nokiDest: Number, product: String, dispColor: String, prodHub: String) => {
    var params = {
      tokCd1: tokCd,
      tokCd2: tokCd2,
      nokiAns: nokiAns,
      orderDateS: orderDateS,
      orderDateE: orderDateE,
      orderNo: orderNo,
      shipStatus: shipStatus,
      nokiDest: nokiDest,
      product: product,
      dispColor: dispColor,
      prodHub: prodHub
    }
    return http.get('JuchuShokai/getSearchList', { params })
  }

  // 受注データ明細更新
  updJyuchuMei = (params: any[]) => {
    return http.post('JuchuShokai/updateTJyuchuMei', { params })
  }
}
export default new JuchuShokaiServ();
